import { buildExposeItem, postAdExpose } from './adExposeReport'

var DURATION = 2000
var FLUSH_DELAY = 2000
var FLUSH_MAX = 40
var POLL_MS = 200

function rectVisible(el, top_inset, bottom_inset) {
  if (!el || !el.getBoundingClientRect) return false
  var r = el.getBoundingClientRect()
  var h = window.innerHeight || document.documentElement.clientHeight
  var w = window.innerWidth || document.documentElement.clientWidth
  var top = top_inset || 0
  var bottom = bottom_inset || 0
  return (
    r.width > 0 &&
    r.height > 0 &&
    r.bottom > top &&
    r.right > 0 &&
    r.top < h - bottom &&
    r.left < w
  )
}

function AdExposeTracker(opt) {
  opt = opt || {}
  this.duration = opt.duration || DURATION
  this.effect_page = opt.effect_page || 'index'
  this.paused = false
  this.queue = []
  this.flush_timer = null
  this.records = []
  this.key_state = {}
  this.manual_keys = {}
  this.top_inset = 0
  this.bottom_inset = 0
  this.observer = null
  this.poll_timer = null
  this.on_visibility = this.onVisibilityHandle.bind(this)
  this.on_pagehide = this.onPagehideHandle.bind(this)
  this.initObserver()
  if (typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', this.on_visibility)
  }
  if (typeof window !== 'undefined') {
    window.addEventListener('pagehide', this.on_pagehide)
  }
}

AdExposeTracker.prototype.initObserver = function () {
  var that = this
  if (typeof IntersectionObserver === 'function') {
    this.observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var e = entries[i]
          that.setElVisible(e.target, !!(e.isIntersecting && e.intersectionRatio > 0))
        }
      },
      { threshold: 0, root: null, rootMargin: '-' + this.top_inset + 'px 0px -' + this.bottom_inset + 'px 0px' }
    )
    return
  }
  this.poll_timer = setInterval(function () {
    that.pollVisible()
  }, POLL_MS)
}

AdExposeTracker.prototype.setRootInsetHandle = function (top, bottom) {
  top = Math.max(0, Math.round(top || 0))
  bottom = Math.max(0, Math.round(bottom || 0))
  if (this.top_inset === top && this.bottom_inset === bottom) return false
  this.top_inset = top
  this.bottom_inset = bottom
  this.rebuildObserverHandle()
  return true
}

AdExposeTracker.prototype.rebuildObserverHandle = function () {
  if (this.observer) {
    try {
      this.observer.disconnect()
    } catch (e) {}
    this.observer = null
  }
  if (this.poll_timer) {
    clearInterval(this.poll_timer)
    this.poll_timer = null
  }
  this.initObserver()
  for (var i = 0; i < this.records.length; i++) {
    this.observeEl(this.records[i].el)
  }
  if (!this.paused) this.pollVisible()
}

AdExposeTracker.prototype.findRec = function (el) {
  for (var i = 0; i < this.records.length; i++) {
    if (this.records[i].el === el) return this.records[i]
  }
  return null
}

AdExposeTracker.prototype.observeEl = function (el) {
  if (!el) return
  if (this.observer) {
    this.observer.observe(el)
  } else {
    this.setElVisible(el, rectVisible(el, this.top_inset, this.bottom_inset))
  }
}

AdExposeTracker.prototype.unobserveEl = function (el) {
  if (!el) return
  if (this.observer) {
    try {
      this.observer.unobserve(el)
    } catch (e) {}
  }
}

AdExposeTracker.prototype.observe = function (el, flow_area, item) {
  if (!el || !flow_area) return
  this.unobserve(el)
  var rec = {
    el: el,
    mode: 'static',
    flow_area: flow_area,
    item: item || {},
    visible: false
  }
  this.records.push(rec)
  this.observeEl(el)
}

AdExposeTracker.prototype.observeCarousel = function (el, opt) {
  if (!el || !opt) return
  this.unobserve(el)
  var rec = {
    el: el,
    mode: 'carousel',
    get_index: opt.get_index,
    get_item: opt.get_item,
    make_key: opt.make_key,
    visible: false,
    timer: null,
    reported_key: '',
    pending_key: ''
  }
  this.records.push(rec)
  this.observeEl(el)
}

AdExposeTracker.prototype.onCarouselChange = function (el) {
  var rec = this.findRec(el)
  if (!rec || rec.mode !== 'carousel') return
  this.clearCarouselTimer(rec)
  rec.reported_key = ''
  rec.pending_key = ''
  if (rec.visible && !this.paused) {
    this.startCarouselTimer(rec)
  }
}

AdExposeTracker.prototype.unobserve = function (el) {
  var rec = this.findRec(el)
  if (!rec) return
  this.setElVisible(el, false)
  this.unobserveEl(el)
  var next = []
  for (var i = 0; i < this.records.length; i++) {
    if (this.records[i].el !== el) next.push(this.records[i])
  }
  this.records = next
}

AdExposeTracker.prototype.setElVisible = function (el, visible) {
  var rec = this.findRec(el)
  if (!rec) return
  if (rec.mode === 'carousel') {
    if (rec.visible === visible) return
    rec.visible = visible
    if (this.paused) return
    if (visible) {
      this.startCarouselTimer(rec)
    } else {
      this.clearCarouselTimer(rec)
      rec.reported_key = ''
      rec.pending_key = ''
    }
    return
  }
  if (rec.visible === visible) return
  rec.visible = visible
  var key = rec.flow_area
  var ks = this.key_state[key]
  if (!ks) {
    ks = this.key_state[key] = { visible: 0, timer: null, reported: false, rec: rec }
  }
  ks.rec = rec
  if (visible) {
    ks.visible++
    if (ks.visible === 1 && !this.paused) {
      this.startKeyTimer(key, ks)
    }
  } else {
    ks.visible--
    if (ks.visible <= 0) {
      ks.visible = 0
      this.clearKeyTimer(ks)
      ks.reported = false
    }
  }
}

AdExposeTracker.prototype.setKeyVisible = function (key, visible, item) {
  if (!key) return
  if (!this.manual_keys) this.manual_keys = {}
  if (visible) this.manual_keys[key] = item || this.manual_keys[key] || {}
  else delete this.manual_keys[key]
  if (this.paused) return
  var ks = this.key_state[key]
  if (!ks) {
    ks = this.key_state[key] = {
      visible: 0,
      timer: null,
      reported: false,
      rec: { flow_area: key, item: item || {}, mode: 'static' }
    }
  } else if (item) {
    if (!ks.rec) ks.rec = { flow_area: key, item: item, mode: 'static' }
    else ks.rec.item = item
  }
  var was = ks.visible > 0
  if (!!visible === was) return
  if (visible) {
    ks.visible = 1
    this.startKeyTimer(key, ks)
  } else {
    ks.visible = 0
    this.clearKeyTimer(ks)
    ks.reported = false
  }
}

AdExposeTracker.prototype.applyManualKeysHandle = function () {
  if (this.paused || !this.manual_keys) return
  var key
  for (key in this.manual_keys) {
    if (!this.manual_keys.hasOwnProperty(key)) continue
    this.setKeyVisible(key, true, this.manual_keys[key])
  }
}

AdExposeTracker.prototype.startKeyTimer = function (key, ks) {
  var that = this
  this.clearKeyTimer(ks)
  ks.timer = setTimeout(function () {
    ks.timer = null
    if (that.paused || ks.visible <= 0 || ks.reported) return
    var rec = ks.rec
    that.enqueue(key, rec ? rec.item : {})
    ks.reported = true
  }, this.duration)
}

AdExposeTracker.prototype.clearKeyTimer = function (ks) {
  if (ks && ks.timer) {
    clearTimeout(ks.timer)
    ks.timer = null
  }
}

AdExposeTracker.prototype.startCarouselTimer = function (rec) {
  var that = this
  this.clearCarouselTimer(rec)
  var idx = 0
  try {
    idx = rec.get_index()
  } catch (e) {
    idx = 0
  }
  if (typeof idx !== 'number' || idx < 0) idx = 0
  var key = rec.make_key(idx)
  rec.pending_key = key
  rec.timer = setTimeout(function () {
    rec.timer = null
    if (that.paused || !rec.visible) return
    var now_idx = 0
    try {
      now_idx = rec.get_index()
    } catch (e2) {
      now_idx = idx
    }
    var now_key = rec.make_key(now_idx)
    if (now_key !== key) return
    if (rec.reported_key === key) return
    var item = {}
    try {
      item = rec.get_item(now_idx) || {}
    } catch (e3) {}
    that.enqueue(key, item)
    rec.reported_key = key
  }, this.duration)
}

AdExposeTracker.prototype.clearCarouselTimer = function (rec) {
  if (rec && rec.timer) {
    clearTimeout(rec.timer)
    rec.timer = null
  }
}

AdExposeTracker.prototype.enqueue = function (flow_area, item) {
  this.queue.push(buildExposeItem(flow_area, item, this.effect_page))
  if (this.queue.length >= FLUSH_MAX) {
    this.flush()
    return
  }
  var that = this
  if (this.flush_timer) clearTimeout(this.flush_timer)
  this.flush_timer = setTimeout(function () {
    that.flush_timer = null
    that.flush()
  }, FLUSH_DELAY)
}

AdExposeTracker.prototype.flush = function () {
  if (this.flush_timer) {
    clearTimeout(this.flush_timer)
    this.flush_timer = null
  }
  if (!this.queue.length) return
  var list = this.queue
  this.queue = []
  postAdExpose(list)
}

AdExposeTracker.prototype.pollVisible = function () {
  if (this.paused) return
  for (var i = 0; i < this.records.length; i++) {
    var rec = this.records[i]
    this.setElVisible(rec.el, rectVisible(rec.el, this.top_inset, this.bottom_inset))
  }
}

AdExposeTracker.prototype.pause = function () {
  this.paused = true
  var key
  for (key in this.key_state) {
    if (!this.key_state.hasOwnProperty(key)) continue
    this.clearKeyTimer(this.key_state[key])
    this.key_state[key].reported = false
    this.key_state[key].visible = 0
  }
  for (var i = 0; i < this.records.length; i++) {
    var rec = this.records[i]
    rec.visible = false
    if (rec.mode === 'carousel') {
      this.clearCarouselTimer(rec)
      rec.reported_key = ''
      rec.pending_key = ''
    }
  }
}

AdExposeTracker.prototype.resume = function () {
  this.paused = false
  this.pollVisible()
  if (this.observer) {
    for (var i = 0; i < this.records.length; i++) {
      this.setElVisible(this.records[i].el, rectVisible(this.records[i].el, this.top_inset, this.bottom_inset))
    }
  }
  this.applyManualKeysHandle()
}

AdExposeTracker.prototype.resetObserve = function () {
  var els = []
  for (var i = 0; i < this.records.length; i++) {
    els.push(this.records[i].el)
  }
  for (var j = 0; j < els.length; j++) {
    this.unobserve(els[j])
  }
  this.key_state = {}
  this.applyManualKeysHandle()
}

AdExposeTracker.prototype.onVisibilityHandle = function () {
  if (typeof document === 'undefined') return
  if (document.hidden) {
    this.pause()
    this.flush()
  } else {
    this.resume()
  }
}

AdExposeTracker.prototype.onPagehideHandle = function () {
  this.flush()
}

AdExposeTracker.prototype.destroy = function () {
  this.pause()
  this.flush()
  this.manual_keys = {}
  this.resetObserve()
  if (this.observer) {
    this.observer.disconnect()
    this.observer = null
  }
  if (this.poll_timer) {
    clearInterval(this.poll_timer)
    this.poll_timer = null
  }
  if (typeof document !== 'undefined') {
    document.removeEventListener('visibilitychange', this.on_visibility)
  }
  if (typeof window !== 'undefined') {
    window.removeEventListener('pagehide', this.on_pagehide)
  }
}

export default AdExposeTracker



// WEBPACK FOOTER //
// ./src/components/homepage/js/adExposeTracker.js